<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <label class="generalLabel" for="vendorCheck"
      >Se va a enviar al cliente una solicitud para que actualice su tarjeta de
      pago. Pulse "Confirmar" para continuar.</label
    >
    <button
      class="btn btn-primary generalPrimaryButton float-right mt-4"
      data-dismiss="modal"
      aria-label="Close"
      @click="confirm()"
    >
      Confirmar
    </button>
  </Modal>
  <ModalError
    :id="'modalError'"
    :modalTitle="'SE HA PRODUCIDO UN ERROR'"
    :class="'modal'"
    :showFooter="false"
    :message="errorMessage"
    :code="errorCode"
  />
</template>

<script>
import Modal from "../../../Shared/Modal.vue"
import ModalError from "../../../Shared/ModalError.vue"
import axios from "axios"
import { Modal as ModalBootstrap } from "bootstrap"
export default {
  name: "ConfirmChangePayMethod",
  props: ["id", "modalTitle", "class", "contractId"],
  data() {
    return {
      classes: this.class,
      errorCode: "",
      errorMessage: ""
    }
  },
  components: {
    Modal,
    ModalError
  },
  methods: {
    confirm() {
      axios
        .post(`/contract/${this.contractId}/payment-plan/change-card`)
        .then(() => {})
        .catch((error) => {
          this.errorCode = error.response.data.code
          this.errorMessage = error.response.data.message
          var myModal = new ModalBootstrap(
            document.getElementById("modalError")
          )
          myModal.show()
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
